module.exports = __webpack_public_path__ + "static/service2-6d9de7f90c0e26e695c2fd1d3376807f.png";